import {
  Autocomplete,
  Button,
  TextField,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import axios from "../axios";
import { useMutation, useQuery } from "react-query";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";
import { useState } from "react";
import { queryClient } from "../index";

const NewClass = () => {
  const { register, handleSubmit } = useForm({
    defaultValues: {
      name: "",
      fee: 0,
    },
  });
  const navigate = useNavigate();
  const [selectedTeacher, setSelectedTeacher] = useState(null);

  const { data: teachers } = useQuery("teachers", () =>
    axios.get("/teachers").then((res) => res.data)
  );

  const newClassMutation = useMutation((data) =>
    axios.post("/classes", data)
  );

  const handleFormSubmission = (data) => {
    newClassMutation.mutate(
      {
        ...data,
        teacherID: selectedTeacher ? selectedTeacher.id : null,
      },
      {
        onSuccess: () => {
          queryClient.invalidateQueries("classes");
          toast.success("Class added successfully");
          navigate("/classes");
        },
        onError: () => {
          toast.error("Error adding class");
        },
      }
    );
  };

  return (
    <div>
      <Typography mb={2} variant="h5" component="h2">
        New Class
      </Typography>
      <Box
        onSubmit={handleSubmit(handleFormSubmission)}
        component="form"
        sx={{
          display: "grid",
          gridTemplateColumns: "repeat(2, 1fr)",
          gap: 2,
        }}
        autoComplete="off"
      >
        <TextField {...register("name")} label="Class name" required />
        <TextField {...register("fee")} label="Fee" type="number" />
        <Autocomplete
          options={teachers || []}
          getOptionLabel={(option) => option.name}
          value={selectedTeacher}
          onChange={(_, value) => setSelectedTeacher(value)}
          renderInput={(params) => (
            <TextField {...params} label="Assign Teacher (optional)" />
          )}
        />
        <div></div>
        <Button type="submit" variant="contained">
          Submit
        </Button>
      </Box>
    </div>
  );
};

export default NewClass;
